<template>
  <svg v-if="!mirror" xmlns="http://www.w3.org/2000/svg" class="inline-block ml-2 -mt-0.5" :style="color ? `fill:${color}` : ''" viewBox="0 0 18.87 11.92" width="18.87" height="11.92">
    <g class="transition-transform duration-200 transform -translate-x-3 group-hover:transform group-hover:translate-x-0"><path d="M13.26.736l5.614 5.615-1.386 1.386-5.614-5.615zM11.872 10.54l3.302-3.301 1.386 1.385-3.303 3.303z" /></g>
    <path class="transition-transform duration-200 transform scale-x-0 group-hover:transform group-hover:scale-x-100" d="M12.98 7.52H5.04V5.56h7.94l1 .98-1 .98z" />
  </svg>
  <svg v-else xmlns="http://www.w3.org/2000/svg" class="inline-block mr-2 -mt-1" :style="color ? `fill:${color}` : ''" viewBox="0 0 18.87 11.92" width="18.87" height="11.92">
    <g class="transition-transform duration-200 transform -translate-x-0.5 group-hover:transform group-hover:translate-x-0"><path d="M13.26.736l5.614 5.615-1.386 1.386-5.614-5.615zM11.872 10.54l3.302-3.301 1.386 1.385-3.303 3.303z" /></g>
    <path class="transition-transform duration-200 origin-center transform scale-x-0 group-hover:transform group-hover:scale-x-100" d="M12.98 7.52H5.04V5.56h7.94l1 .98-1 .98z" />
  </svg>
</template>

<script>
export default {
  name: 'EllevioWebLinkIcon',
  props: {
    color: {
      type: String,
      default: ''
    },
    mirror: {
      type: Boolean,
      default: false
    }
  }
}
</script>
